import { Action } from 'redux';
import { AccessTokenPayload, AccessToken, AccessTokenType } from '@dev/ee-api/ee-api-models';

export interface LoadAccessTokensAction extends Action {
    type: '@@security/FETCH_ACCESS_TOKENS';
    payload: {
        accessTokensLoading: boolean;
    };
}
export interface LoadAccessTokensSuccessAction extends Action {
    type: '@@security/FETCH_ACCESS_TOKENS_SUCCESS';
    payload: {
        accessTokens: AccessToken[];
        accessTokensLoading: boolean;
    };
}
export interface LoadAccessTokensErrorAction extends Action {
    type: '@@security/FETCH_ACCESS_TOKENS_ERROR';
    payload: {
        accessTokensLoading: boolean;
    };
}
export interface AddAccessTokenAction extends Action {
    type: '@@security/ADD_ACCESS_TOKEN';
    payload: {
        accessToken: AccessTokenPayload;
        accessTokensLoading: boolean;
    };
}
export interface AddAccessTokenErrorAction extends Action {
    type: '@@security/ADD_ACCESS_TOKEN_ERROR';
    payload: {
        accessTokensLoading: boolean;
    };
}
export interface AddAccessTokenSuccessAction extends Action {
    type: '@@security/ADD_ACCESS_TOKEN_SUCCESS';
    payload: {
        accessTokens: AccessToken[];
        accessTokensLoading: boolean;
    };
}
export interface DeleteAccessTokenAction extends Action {
    type: '@@security/DELETE_ACCESS_TOKEN';
    payload: {
        name: string;
        type: AccessTokenType;
    };
}
export interface DeleteAccessTokenSuccessAction extends Action {
    type: '@@security/DELETE_ACCESS_TOKEN_SUCCESS';
}
export interface DeleteAccessTokenErrorAction extends Action {
    type: '@@security/DELETE_ACCESS_TOKEN_ERROR';
}
export interface UpdateAccessTokenAction extends Action {
    type: '@@security/UPDATE_ACCESS_TOKEN';
    payload: {
        name: string;
        accessToken: AccessTokenPayload;
    };
}
export interface UpdateAccessTokenErrorAction extends Action {
    type: '@@security/UPDATE_ACCESS_TOKEN_ERROR';
}
export interface UpdateAccessTokenSuccessAction extends Action {
    type: '@@security/UPDATE_ACCESS_TOKEN_SUCCESS';
    payload: {
        accessTokens: AccessToken[];
    };
}
export interface ShowAccessTokenCredentialsAction extends Action {
    type: '@@security/SHOW_ACCESS_TOKEN_CREDENTIALS';
    payload: {
        token: string;
        name: string;
        type: AccessTokenDialogTypeEnum;
        tokenType: number;
    };
}
export interface HideAccessTokenCredentialsAction extends Action {
    type: '@@security/HIDE_ACCESS_TOKEN_CREDENTIALS';
}
export interface ChangeAccessTokenAction extends Action {
    type: '@@security/CHANGE_ACCESS_TOKEN';
    payload: {
        name: string;
        tokenType: AccessTokenType;
    };
}
export interface ChangeAccessTokenSuccessAction extends Action {
    type: '@@security/CHANGE_ACCESS_TOKEN_SUCCESS';
}
export interface ChangeAccessTokenErrorAction extends Action {
    type: '@@security/CHANGE_ACCESS_TOKEN_ERROR';
}

export enum AccessTokenDialogTypeEnum {
    EditToken = 'editToken',
    ChangePassword = 'changePassword',
    Delete = 'delete',
}

export type AccessTokensActions =
    | AddAccessTokenAction
    | AddAccessTokenErrorAction
    | AddAccessTokenSuccessAction
    | LoadAccessTokensAction
    | LoadAccessTokensErrorAction
    | LoadAccessTokensErrorAction
    | DeleteAccessTokenAction
    | DeleteAccessTokenSuccessAction
    | DeleteAccessTokenErrorAction
    | UpdateAccessTokenAction
    | UpdateAccessTokenErrorAction
    | UpdateAccessTokenSuccessAction;

export interface SecurityState {
    accessTokensLoading: boolean;
    accessTokens?: AccessToken[];
    dialogCredentials?: { name: string; token: string; type: AccessTokenDialogTypeEnum; tokenType?: number };
}
